var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllustrationContactus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48317 77.9709C4.35823 52.19 27.1198 31.8358 53.6521 18.5311C80.3648 5.13586 113.738 -3.16201 143.573 7.72203C171.814 18.0243 181.446 44.7188 190.716 68.5329C199.169 90.2482 209.593 115.805 192.172 132.574C175.764 148.37 144.389 136.99 118.394 138.153C94.3385 139.229 70.3247 149.828 49.5646 138.956C23.5505 125.331 2.65257 102.442 3.48317 77.9709Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.154 99.8119C111.224 99.8119 95.0679 83.5314 95.0679 63.4483C95.0679 43.3652 111.224 27.0847 131.154 27.0847C151.084 27.0847 167.24 43.3652 167.24 63.4483C167.24 69.2653 165.884 74.7633 163.474 79.6391C162.834 80.9348 162.621 82.4158 162.992 83.8142L165.141 91.9088C166.074 95.4228 162.884 98.6376 159.397 97.6973L151.364 95.5315C149.977 95.1573 148.507 95.3722 147.221 96.0175C142.382 98.4461 136.926 99.8119 131.154 99.8119Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.837 62.6959L116.968 62.6959",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.335 54.6709H117.466",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.335 71.2226L116.968 71.2226",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6109 123.887C102.929 123.887 116.968 109.74 116.968 92.2884C116.968 74.8369 102.929 60.6897 85.6109 60.6897C68.2926 60.6897 54.2534 74.8369 54.2534 92.2884C54.2534 97.3432 55.4312 102.121 57.5254 106.358C58.082 107.484 58.2672 108.771 57.9445 109.986L56.0769 117.02C55.2661 120.073 58.0383 122.867 61.0685 122.05L68.0488 120.168C69.2546 119.843 70.5317 120.029 71.649 120.59C75.8536 122.7 80.5947 123.887 85.6109 123.887Z",
    fill: "#009B63",
    stroke: "#009B63",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6652 91.7869L98.552 91.7869",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1674 84.7649H98.0543",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1674 98.8088L98.552 98.8088",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 188.397,
    y: 88,
    width: 23.8167,
    height: 24,
    rx: 4,
    fill: "#3E4FE0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M203.886 93.5913L204.372 93.1047C205.179 92.2984 206.486 92.2984 207.292 93.1047C208.098 93.9109 208.098 95.2181 207.292 96.0244L206.806 96.511M203.886 93.5913C203.886 93.5913 203.947 94.6253 204.859 95.5377C205.771 96.4501 206.806 96.511 206.806 96.511M203.886 93.5913L199.412 98.0649C199.109 98.368 198.958 98.5195 198.827 98.6865C198.674 98.8836 198.542 99.0968 198.434 99.3224C198.343 99.5136 198.275 99.7169 198.14 100.123L197.706 101.425M206.806 96.511L202.332 100.985C202.029 101.288 201.877 101.439 201.71 101.569C201.513 101.723 201.3 101.855 201.074 101.962C200.883 102.054 200.68 102.121 200.273 102.257L198.972 102.691M198.972 102.691L198.13 102.971C197.93 103.038 197.709 102.986 197.56 102.837C197.411 102.688 197.359 102.467 197.425 102.267L197.706 101.425M198.972 102.691L197.706 101.425",
    stroke: "white",
    strokeWidth: 1.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M207.897 100C207.897 104.142 204.539 107.5 200.397 107.5C196.255 107.5 192.897 104.142 192.897 100C192.897 95.8579 196.255 92.5 200.397 92.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9264 45C32.9264 51.2854 32.9264 54.4281 30.9887 56.3807C29.051 58.3334 25.9323 58.3334 19.6949 58.3334C13.4575 58.3334 10.3388 58.3334 8.40108 56.3807C6.46336 54.4281 6.46336 51.2854 6.46336 45C6.46336 38.7146 6.46336 35.5719 8.40108 33.6193C10.3388 31.6667 13.4575 31.6667 19.6949 31.6667",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1925 33.579L28.3115 36.303C30.4586 38.1781 31.5321 39.1156 31.5321 40.3333C31.5321 41.551 30.4586 42.4885 28.3115 44.3637L25.1925 47.0876C24.2484 47.9121 23.7763 48.3244 23.3896 48.1464C23.0028 47.9685 23.0028 47.339 23.0028 46.08V44.0476C19.0333 44.0476 14.7331 45.9047 13.0791 49C13.0791 39.0952 18.9598 36.619 23.0028 36.619V34.5866C23.0028 33.3276 23.0028 32.6982 23.3896 32.5202C23.7763 32.3422 24.2484 32.7545 25.1925 33.579Z",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustrationContactus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/illustration-contactus.6abfb5aadb2d540b9c694ae421cf6666.svg";